export const values = [
  { icon: "HiSparkles", title: "Professionnalisme", description: "Une expertise fiscale et patrimoniale éprouvée" },
  { icon: "HiLightningBolt", title: "Ponctualité et fiabilité", description: "Nous tenons nos engagements avec rigueur et respect des délais" },
  { icon: "HiShieldCheck", title: "Expertise", description: "Des conseils précis, personnalisés et toujours dans l'intérêt du client" }
];

export const founders = [
  {
    name: "Emir",
    description: "Fort de 10 ans d'expérience, Emir accompagne ses clients aussi bien sur leurs déclarations fiscales que sur l'ensemble de leur gestion de patrimoine.",
    trait: "L'expérience"
  },
  {
    name: "Tristan",
    description: "Tristan bénéficie d'une solide expérience en relation client, immobilier, courtage et gestion de patrimoine, avec une approche très orientée accompagnement et pédagogie.",
    trait: "La fougue"
  }
];

export const steps = [
  { number: "1", title: "Audit initial", description: "Collecte des documents" },
  { number: "2", title: "Réalisation", description: "Préparation et validation" },
  { number: "3", title: "Suivi patrimonial", description: "Accompagnement continu" }
];
